// extracted by mini-css-extract-plugin
export default {"menu":"styles-module__menu--dKbuV","signUpTitle":"styles-module__signUpTitle--My3na","headerRoot":"styles-module__headerRoot--WL33V","logoCntr":"styles-module__logoCntr--dXNts"};